import React from "react";
import { Card, Row, Col, Typography, Tooltip } from "antd";
import { useNavigate } from "react-router-dom";
import {
  SettingOutlined,
  DatabaseOutlined,
  ExperimentOutlined,
  BookOutlined,
  FileImageOutlined,
  DashboardOutlined
} from "@ant-design/icons";
import { useAuth } from "../component/AuthContext";
import { PERMISSIONS } from "../component/permissions";

const { Title, Text } = Typography;

const menuItems = [
  {
    title: "System Management",
    path: "/system-management",
    icon: <SettingOutlined style={{ fontSize: 24 }} />,
    description: "Configure and manage system settings",
    color: "#1890ff",
    perm: PERMISSIONS.SYSTEM_MANAGEMENT,
  },
  {
    title: "Dataset Management",
    path: "/dataset-management",
    icon: <DatabaseOutlined style={{ fontSize: 24 }} />,
    description: "Manage and organize datasets",
    color: "#52c41a",
    perm: PERMISSIONS.DATASET_MANAGEMENT,
  },
  {
    title: "Model Management",
    path: "/model-management",
    icon: <ExperimentOutlined style={{ fontSize: 24 }} />,
    description: "View and configure models",
    color: "#722ed1",
    perm: PERMISSIONS.MODEL_MANAGEMENT,
  },
  {
    title: "Teachmode",
    path: "/teachmode",
    icon: <BookOutlined style={{ fontSize: 24 }} />,
    description: "Training and learning interface for missed defects",
    color: "#fa8c16",
    perm: PERMISSIONS.TEACHMODE,
  },
  {
    title: "Image View",
    path: "/image-view",
    icon: <FileImageOutlined style={{ fontSize: 24 }} />,
    description: "View and analyze images",
    color: "#eb2f96",
    perm: PERMISSIONS.IMAGE_VIEW,
  },
  {
    title: "Dashboard",
    path: "/dashboard",
    icon: <DashboardOutlined style={{ fontSize: 24 }} />,
    description: "View system analytics",
    color: "#13c2c2",
    perm: PERMISSIONS.DASHBOARD,
  }
];

const HomePage: React.FC = () => {
  const { canRead } = useAuth();
  const navigate = useNavigate();

  const handleCardClick = (path: string) => navigate(path);
  const handleKeyDown = (e: React.KeyboardEvent, path: string) => {
    if (e.key === "Enter") handleCardClick(path);
  };

  return (
    <div style={{ background: "#505865", padding: 24, minHeight: "85vh" }}>
      <Card bordered={false} className="shadow-md">
        <Title level={3} className="mb-6 text-center">
          Welcome to Client Portal
        </Title>
        <Row gutter={[16, 16]} justify="center">
          {menuItems
            .filter(item => canRead(item.perm))
            .map((item, idx) => (
              <Col xs={24} sm={12} md={8} key={idx}>
                <Card
                  hoverable
                  role="button"
                  tabIndex={0}
                  onClick={() => handleCardClick(item.path)}
                  onKeyDown={(e) => handleKeyDown(e, item.path)}
                  style={{ borderTop: `2px solid ${item.color}` }}
                  bodyStyle={{ padding: 24 }}
                >
                  <div className="flex flex-col items-center text-center">
                    <Tooltip title={item.description}>
                      <div style={{ color: item.color, marginBottom: 16 }}>
                        {item.icon}
                      </div>
                    </Tooltip>
                    <Title level={4} style={{ margin: "0 0 8px 0" }}>
                      {item.title}
                    </Title>
                    <Text type="secondary">{item.description}</Text>
                  </div>
                </Card>
              </Col>
            ))}
        </Row>
      </Card>
    </div>
  );
};

export default HomePage;
